//No language available for el-GR, ro-RO and ko-KR, so they are using default (www)

import type { TrustPilotWidgetConfig } from "./contract";

const SITE_LANGUAGES = {
  "en-GB": "uk",
  "en-AU": "uk",
  "en-US": "www",
  "en-CA": "www",
  "en-ZA": "www",
  "en-NZ": "www",
  "en-CZ": "www",
  "en-SG": "www",
  "en-PH": "www",
  "en-TH": "www",
  "en-KR": "www",
  "en-AE": "www",
  "en-HK": "www",
  "en-HU": "www",
  "en-ID": "www",
  "en-IN": "www",
  "fr-FR": "fr",
  "fr-CH": "fr",
  "fr-CA": "fr",
  "fr-MA": "fr",
  "it-IT": "it",
  "it-CH": "it",
  "de-DE": "de",
  "de-CH": "ch",
  "de-AT": "at",
  "pt-PT": "pt",
  "es-ES": "es",
  "es-MX": "es",
  "es-CO": "es",
  "es-CL": "es",
  "es-US": "es",
  "ar-AE": "ar",
  "nl-NL": "nl",
  "pl-PL": "pl",
  default: "www",
};

const BRAND_NAMES = {
  OP: "opodo",
  GO: "govoyages",
  default: "edreams",
};

const DATA_TEMPLATE_IDS = {
  SLIDER: "54ad5defc6454f065c28af8b",
  MICRO: "5419b6ffb0d04a076446a9af",
  MINI: "53aa8807dec7e10d38f59f32",
};

const DATA_TEMPLATE_HEIGHT = {
  SLIDER: "240px",
  MICRO: "20px",
  MINI: "150px",
};

const DATA_BUSINESSUNIT_IDS = {
  OP: "496b0d800000640005040a6e",
  GO: "477447a00000640005020977",
  default: "4e5d0175000064000510e135",
};

export const getTrustPilotWidgetConfig = (
  brand: string,
  locale: string,
  trustPilotType: string,
): TrustPilotWidgetConfig => {
  const siteLanguage = SITE_LANGUAGES[locale] || SITE_LANGUAGES.default;
  const brandName = BRAND_NAMES[brand] || BRAND_NAMES.default;
  const dataTemplateId = DATA_TEMPLATE_IDS[trustPilotType];
  const dataBusinessUnitId =
    DATA_BUSINESSUNIT_IDS[brand] || DATA_BUSINESSUNIT_IDS.default;
  const dataTemplateHeight = DATA_TEMPLATE_HEIGHT[trustPilotType];
  const url = `https://${siteLanguage}.trustpilot.com/review/www.${brandName}.com`;

  return {
    dataTemplateId,
    dataBusinessUnitId,
    dataTemplateHeight,
    url,
  };
};

export const TRUSTPILOT_COMPONENT_ID = "trustpilot-component";
